import { UploadHistoryView } from "@/features/patient/records/components/UploadHistoryView";
import { useFamily } from "@/portals/patient/context/FamilyContext";
import { useProfileFromQuery } from "@/portals/patient/hooks/useProfileFromQuery";

export function UploadHistoryPage() {
  // An IDENTITY_UNCONFIRMED notification for a dependent's upload opens here
  // with ?profile=<dependent id>.
  useProfileFromQuery();
  const { activeDependent } = useFamily();
  return <UploadHistoryView actingAsProfileId={activeDependent?.id} />;
}
